import React from "react";

import RestrictedSection from "./RestrictedSection";

const MentorsOnly: React.FunctionComponent = ({ children }) => {
	return <RestrictedSection isMentorsOnly>{children}</RestrictedSection>;
};

export default MentorsOnly;
